export const firebaseConfig = {
  apiKey: 'AIzaSyAaSp1U7AY3KEOAcOUwjoruwe1sr8sFptE',
  authDomain: 'fitness-c1034.firebaseapp.com',
  databaseURL: 'https://fitness-c1034.firebaseio.com',
  projectId: 'fitness-c1034',
  storageBucket: 'fitness-c1034.appspot.com',
  messagingSenderId: '917354958341'
}
